import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import Select from './Select'
import auth from '../utils/auth'
import cfg from '../utils/config'
import axios from 'axios'
import helper from '../utils/helper'
import tourManager from '../tours'
import demoSession from '../tours/demo/DemoSession'
import { syncTourAccessBodyClass } from '../tours/tourUi'

import {Collapse, Navbar, NavbarToggler, Nav, NavItem, UncontrolledDropdown,DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody,} from 'reactstrap'

const labelRecursosBuscaveis = {
    "clientes": {
        "label": "Clientes",
        "url": "/cliente/:id/editar",
        "campo": "nome_fantasia"
    },
    "usuarios": {
        "label": "Usuários",
        "url": "/usuario/:id/editar",
        "campo": "nome"
    },
    "perfis_cliente": {
        "label": "Perfis de Cliente",
        "url": "/perfil/cliente/:id/editar",
        "campo": "nome"
    },
    "perfis_usuario": {
        "label": "Perfis de Usuário",
        "url": "/perfil/usuario/:id/editar",
        "campo": "nome"
    },
    "equipamentos": {
        "label": "Equipamentos",
        "url": "/equipamento/:id/editar",
        "campo": "imei"
    },
    "monitorados": {
        "label": "Monitorados",
        "url": "/status/:id",
        "campo": "nome"
    },
    "automacoes": {
        "label": "Automações",
        "url": "/automacao/:id/editar",
        "campo": "descricao"
    },
    "comandos": {
        "label": "Comandos",
        "url": "/comando-customizado/:id/editar/",
        "campo": "descricao",
        "refCampo": "equipamento",
        "prefixoId": "equipamento_id",
    },
    "parametros": {
        "label": "Parâmetros",
        "url": "/campo-parametrizado/:prefixoId/editar/:id",
        "campo": "descricao",
        "refCampo": "equipamento",
        "prefixoId": "equipamento_id",
    },
    "relatorios_customizados": {
        "label": "Relatórios Customizados",
        "url": "/relatorio-customizado/:id/editar",
        "campo": "descricao"
    },
    "relatorios_consumo": {
        "label": "Relatórios de Consumo",
        "url": "/relatorio-consumo/:id/editar",
        "campo": "descricao"
    },
    "exportacoes": {
        "label": "Exportações",
        "url": "/exportacao-dados/:id/editar",
        "campo": "descricao"
    },
    "outorgas": { "label": "Outorgas", "url": "/ambiental/outorga/:id/editar", "campo": "nome" },
    "sideccr": { "label": "SIDECCR", "url": "/sideccr/:id/editar", "campo": "usuario" },
    "mira": { "label": "MIRA", "url": "/mira/:id/editar", "campo": "descricao" },
    "ana": { "label": "ANA", "url": "/ana/:id/editar", "campo": "descricao" },
    "aplicacoes_lns": { "label": "Aplicações", "url": "/lns/application/:id/editar", "campo": "name" },
    "perfis_dispositivo_lns": { "label": "Perfis de Dispositivo", "url": "/lns/device/profile/:id/editar", "campo": "name" },
    "redirecionamentos_lns": { "label": "Redirecionamentos", "url": "/lns/redirecionamentos/:id/editar", "campo": "nome" },
    "planos_lns": { "label": "Planos", "url": "/lns/planos/:id/editar", "campo": "nome" }
}

const recursosPorModulo = {
    base: ['clientes', 'usuarios', 'perfis_cliente', 'perfis_usuario', 'equipamentos', 'monitorados', 'automacoes', 'comandos', 'parametros', 'relatorios_customizados', 'relatorios_consumo', 'exportacoes'],
    ambiental: ['outorgas', 'sideccr', 'mira', 'ana'],
    lns: ['aplicacoes_lns', 'perfis_dispositivo_lns', 'redirecionamentos_lns', 'planos_lns']
}

const nomesModulos = { base: 'Base', ambiental: 'Ambiental', lns: 'LNS' }

const permissaoPorRecurso = {
    clientes: '/cliente', usuarios: '/usuario', perfis_cliente: '/cliente/perfil',
    perfis_usuario: '/usuario/perfil', equipamentos: '/equipamento',
    monitorados: '/monitorado-status', automacoes: '/automacao',
    comandos: '/equipamento', parametros: '/equipamento',
    relatorios_customizados: '/relatorio', relatorios_consumo: '/relatorio/consumo',
    exportacoes: '/exportacao-dados', outorgas: '/ambiental/outorga',
    sideccr: '/sideccr', mira: '/mira', ana: '/ana',
    aplicacoes_lns: '/lns/application', perfis_dispositivo_lns: '/lns/device/profile',
    redirecionamentos_lns: '/lns/redirecionamentos', planos_lns: '/lns/planos'
}

const recursosSemRotaCliente = ['clientes', 'equipamentos', 'comandos', 'parametros', 'planos_lns']

class MenuBar extends Component {
    constructor(props) {
        super(props)
        this.toggle = this.toggle.bind(this)
        this.searchRequestId = 0

        let empresaAtual, empresaPai

        try {
            const me = localStorage.getItem('__hidroview__me')
            empresaAtual = JSON.parse(me)?.empresa
            empresaPai = JSON.parse(me)?.pai
        } catch (err) {
            console.error(err)
        }

        this.state = {
            isOpen: false,
            alertCount: 0,
            intervalFn: false,
            search: { value: "", open: false, loading: false, error: false },
            modal: false,
            empresas: [],
            empresaSelecionada: false,
            empresaAtual: empresaAtual,
            empresaPai: empresaPai,
            userInfo: auth.getUserInfo()
        }
    }

    componentWillMount = () => {
        let userInfo = auth.getUserInfo()
        this.setState({ imagem_perfil: userInfo['imagem_perfil'] })

        this.checarAlertas()
        let intervalFn = setInterval(this.checarAlertas.bind(this), 60_000)
        this.setState({ intervalFn })
    }

    componentDidMount = () => {
        syncTourAccessBodyClass()
        tourManager.setHistory(this.props.history)
        tourManager.resumeIfPending()
        demoSession.bootstrap()
    }

    componentWillUnmount = () => {
        clearInterval(this.state.intervalFn)
        clearTimeout(this.searchTimer)
        if (this.searchController) this.searchController.abort()
        this.searchRequestId = (this.searchRequestId || 0) + 1
    }

    getEmpresas = () => {
        let empresaId = auth.getUserInfo().empresa
        let empresaPai = JSON.parse(localStorage.getItem('__hidroview__me'))
        if (empresaPai.pai)
            empresaId = empresaPai.pai

        const config = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        axios.get(cfg.base_api_url + cfg.api_v2 + `/${empresaId}/empresa/`, config)
            .then(res => this.setState({ empresas: res.data?.results ?? [] }))
            .catch(console.error)
    }

    acessarEmpresa = async () => {
        const { empresaSelecionada } = this.state
        if (!empresaSelecionada) return
        auth.setChangedEmpresa(empresaSelecionada.id)
        await helper.getLocalStorageMeInfos().then(data => {
            data['pai'] = data.empresa
            data['empresa'] = empresaSelecionada.id
            auth.setUserInfo(data, true)
        })
        window.location.replace('/')
    }

    retornarAoPai = async () => {
        auth.removeChangedEmpresa()
        await helper.getLocalStorageMeInfos().then(data => {
            data['pai'] = null
            data['empresa'] = data.empresa
            auth.setUserInfo(data, true)
        })
        window.location.replace('/')
    }

    toggle() {
        this.setState({ isOpen: !this.state.isOpen })
    }

    toggleModal = () => {
        this.setState({ modal: !this.state.modal })
    }

    handleHelpTourClick = () => {
        if (demoSession.isActive()) {
            if (demoSession.isExitConfirmOpen()) return
            demoSession.handleHelpClick()
            return
        }

        const pathname = this.props.location?.pathname || window.location.pathname
        const naDashboard = pathname === '/' || pathname === ''

        if (naDashboard) {
            tourManager.start('introdutorio')
            return
        }

        helper.dispatchEvent('showAviso', {
            message: 'Ao iniciar o tour você será direcionado para a Dashboard e sairá desta tela. Deseja continuar?',
            callbackLabel: 'Ir para o tour',
            callbackLabelClose: 'Cancelar',
            callback: () => tourManager.start('introdutorio'),
        })
    }

    checarAlertas = () => {
        let userInfo = auth.getUserInfo()
        let requestCfg = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        if (userInfo?.['empresa']) {
            axios.get(cfg.base_api_url + cfg.api_v2 + '/' + userInfo?.['empresa'] + '/checar-alerta/', requestCfg)
                .then(res => this.setState({ alertCount: res.data.count }))
                .catch(console.error)
        }
    }

    buscar = (e) => {
        if (e.key === 'Enter' && this.state.search.value.trim().length >= 2) {
            if (this.state.search.loading && this.termoEmBusca === this.state.search.value.trim()) return
            clearTimeout(this.searchTimer)
            if (this.searchController) this.searchController.abort()
            const requestId = ++this.searchRequestId
            this.executarBusca(this.state.search.value.trim(), requestId)
        }
        if (e.key === 'Escape') this.limpaPesquisa()
    }

    alterarPesquisa = (e) => {
        const value = e.target.value
        clearTimeout(this.searchTimer)
        if (this.searchController) this.searchController.abort()
        const requestId = ++this.searchRequestId
        if (value.trim().length < 2) {
            this.setState({ search: { value, open: false, loading: false, error: false } })
            return
        }
        this.setState({ search: { value, open: false, loading: false, error: false } })
        this.searchTimer = setTimeout(() => this.executarBusca(value.trim(), requestId), 800)
    }

    executarBusca = (termo, requestId) => {
        if (requestId !== this.searchRequestId) return
        this.termoEmBusca = termo
        const userInfo = auth.getUserInfo()
        const url = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/buscar-recurso/'
        this.searchController = new AbortController()
        const config = { headers: { Authorization: 'Bearer ' + auth.getToken() }, params: { q: termo }, signal: this.searchController.signal }
        this.setState({ search: { value: this.state.search.value, open: true, loading: true, error: false } })
        axios.get(url, config).then(res => {
            if (requestId === this.searchRequestId) {
                this.setState({ search: { value: this.state.search.value, open: true, loading: false, error: false, ...res.data } })
            }
        }).catch(err => {
            if (axios.isCancel(err)) return
            if (requestId === this.searchRequestId) {
                this.setState({ search: { value: this.state.search.value, open: true, loading: false, error: true } })
            }
        })
    }

    limpaPesquisa = () => {
        clearTimeout(this.searchTimer)
        if (this.searchController) this.searchController.abort()
        this.searchRequestId = (this.searchRequestId || 0) + 1
        this.setState({ search: { value: "", open: false, loading: false, error: false } })
    }

    abrirResultado = (path) => {
        this.limpaPesquisa()
        this.props.history.push(path)
    }

    getToken = () => {
        navigator.clipboard.writeText(auth.getToken())
    }

    render() {
        syncTourAccessBodyClass()
        const { empresaAtual, empresaPai, search } = this.state
        const modulosDisponiveis = (auth.getUserInfo()?.menu || []).map(modulo => modulo.item)
        const permissoes = auth.getUserInfo()?.permissions || {}
        const grupos = modulosDisponiveis.filter(modulo => recursosPorModulo[modulo]).map(modulo => ({
            modulo,
            recursos: recursosPorModulo[modulo].filter(recurso => {
                if (auth.isClient() && recursosSemRotaCliente.includes(recurso)) return false
                if (!auth.isMasterOrAdmin() && !(permissaoPorRecurso[recurso] in permissoes)) return false
                const dados = modulo === 'base' ? search[recurso] : search[modulo]?.[recurso]
                return Array.isArray(dados) && dados.length > 0
            })
        })).filter(grupo => grupo.recursos.length > 0)
        const colourStyles = {
            option: (styles) => {
                return {
                    ...styles,
                    color: '#000',
                    display: 'flex',
                    justifyContent: 'space-between'
                }
            },
        }

        let empresaOption = []
        if (this.state.empresas.length > 0) {
            this.state.empresas.map((empresa, index) => {
                if (empresa.id !== empresaAtual) {
                    empresaOption.push(
                        {
                            value: index,
                            label: empresa.nome_fantasia,
                            empresa: empresa
                        }
                    )
                }
                return null
            })
        }

        return (
            <div className="hdv-top-menu-position">

                <Navbar className="hdv-menubar" color="" light expand="md">
                    <Nav>
                        <NavItem>
                            <div className="search-bar">
                                <input
                                    className="hdv-search-home-field"
                                    type="text"
                                    name="search"
                                    id="search"
                                    value={search.value}
                                    placeholder="Pesquisar..."
                                    aria-label="Pesquisar na plataforma"
                                    aria-controls="global-search-results"
                                    aria-expanded={search.open}
                                    onKeyDown={this.buscar}
                                    onChange={this.alterarPesquisa}
                                />
                                <button type="button" aria-label="Limpar pesquisa" onClick={this.limpaPesquisa}>
                                    <i className={search.value.length > 0 ? "fa fa-times fa-3x search-input-icon" : "fa fa-search fa-3x search-input-icon"} aria-hidden="true"></i>
                                </button>
                            </div>
                            <div id="global-search-results" role="region" aria-label="Resultados da pesquisa" className={search.open ? "hdv-search-results" : "hdv-noshow-item"}>
                                {search.loading ? <span>Pesquisando...</span> : null}
                                {search.error ? <span>Não foi possível pesquisar. Tente novamente.</span> : null}
                                {!search.loading && !search.error && grupos.length === 0 ? <span>Nenhum resultado encontrado.</span> : null}
                                {!search.loading && !search.error && grupos.length > 0 ? <div className="hdv-search-results-scroll">{grupos.map(grupo => (
                                    <section key={grupo.modulo}>
                                        <span>{nomesModulos[grupo.modulo]}</span>
                                        {grupo.recursos.map(recurso => {
                                            const config = labelRecursosBuscaveis[recurso]
                                            const dados = grupo.modulo === 'base' ? search[recurso] : search[grupo.modulo][recurso]
                                            return <ul key={recurso}>
                                                <span>{config.label}</span>
                                                {dados.map((item, index) => (
                                                    <li key={`${recurso}-${item.id}-${index}`}
                                                        role="button"
                                                        tabIndex={0}
                                                        onClick={() => this.abrirResultado(config.url.replace(':prefixoId', item[config.prefixoId]).replace(':id', item.id))}
                                                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.abrirResultado(config.url.replace(':prefixoId', item[config.prefixoId]).replace(':id', item.id)) } }}>
                                                        <span>{config.refCampo && item[config.refCampo] ? `${item[config.refCampo]} - ` : null}{item[config.campo] || item.id}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        })}
                                    </section>
                                ))}</div> : null}
                            </div>
                        </NavItem>
                    </Nav>
                    <NavbarToggler onClick={this.toggle} />
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="ml-auto d-flex align-items-center" navbar>
                            {auth.isMasterOrAdmin() ? (
                            <NavItem>
                                <span
                                    className="nav-link hdv-navbar-item"
                                    title="Ajuda"
                                    onClick={this.handleHelpTourClick}
                                >
                                    <i className="las la-question-circle hdv-help-tour-icon"></i>
                                </span>
                            </NavItem>
                            ) : null}

                            <NavItem>
                                <Link to="/lista-alertas" className="nav-link hdv-navbar-item" style={{ position: "relative" }}>
                                    <i className="fa fa-bell fa-2x hdv-menu-image-top"></i>
                                    <span
                                        style={(this.state.alertCount === 0) ? { 'backgroundColor': 'silver' } : { 'backgroundColor': '#d94545' }}
                                        className="hdv-alert-receive">{this.state.alertCount}
                                    </span>
                                </Link>
                            </NavItem>

                            <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle nav className="hdv-navbar-item">
                                    <span className="user-name">{auth.getUserInfo().nome}</span>
                                    <span className="hdv-image-round" style={{
                                        backgroundImage: "url(" + this.state.imagem_perfil + ")",
                                        backgroundPosition: 'center',
                                        backgroundSize: 'cover',
                                        backgroundRepeat: 'no-repeat',
                                        width: '50px',
                                        height: '50px',
                                    }}>
                                    </span>
                                </DropdownToggle>
                                <DropdownMenu className="mini-modal" right>
                                    {process.env.NODE_ENV === 'development'
                                        ?
                                        <DropdownItem tag="a" onClick={this.getToken}>
                                            <span className="menu-bar-dropdown-item">
                                                <i className="fa fa-key fa-2x"></i>
                                                Obter Token
                                            </span>
                                        </DropdownItem>
                                        :
                                        null
                                    }

                                    {
                                        auth.isPai() ?
                                            <>
                                                <DropdownItem tag="a" onClick={() => { this.toggleModal(); this.getEmpresas() }}>
                                                    <span className="menu-bar-dropdown-item">
                                                        <i className="fa fa-industry fa-2x"></i>
                                                        Outras empresas
                                                    </span>
                                                </DropdownItem>
                                                <DropdownItem divider />
                                            </>
                                        : null
                                    }
                                    <DropdownItem tag="a" onClick={() => { auth.clearAppStorage(); window.location.reload() }}>
                                        <span className="menu-bar-dropdown-item">
                                            <i className="fa fa-times fa-2x"></i> Sair
                                        </span>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </Nav>
                    </Collapse>
                </Navbar>
                <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>Acessar Empresa</ModalHeader>
                    <ModalBody>
                        <label>Empresas</label>
                        <Select
                            onChange={(e) => this.setState({ empresaSelecionada: e.empresa })}
                            options={empresaOption}
                            placeholder="Selecione"
                            styles={colourStyles}
                        />

                        <div className="float-right justify-content-between" style={{ marginTop: '25px' }}>
                            <button
                                className='hdv-btn-forms mx-0 mr-1'
                                style={{
                                    padding: "0 12px",
                                    color: auth.isPai() && auth.getUserInfo().pai === null ? '#444' : '#fff',
                                    backgroundColor: auth.isPai() && auth.getUserInfo().pai === null ? "#6c757d" : "#007bff"
                                }}
                                disabled={auth.isPai() && auth.getUserInfo().pai === null}
                                onClick={() => this.retornarAoPai()}>
                                Retornar à Empresa Principal
                            </button>
                            {' '}
                            <button
                                className="hdv-btn-forms hdv-btn-blue mx-0 mr-1"
                                style={{ padding: "0 12px" }}
                                disabled={!Boolean(this.state.empresaSelecionada)}
                                onClick={() => this.acessarEmpresa()}>
                                Acessar
                            </button>
                            {' '}
                            <button
                                className="hdv-btn-forms mx-0 hdv-btn-default"
                                style={{ padding: "0 12px" }}
                                onClick={() => this.toggleModal()}>
                                Fechar
                            </button>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

export default withRouter(MenuBar)
